import { computed, unref } from 'vue';
import { useStore } from 'vuex';

const DEFAULT_IMPRINT_URL =
  process.env.VUE_APP_DEFAULT_IMPRINT_URL ||
  'https://www.rupertseewald.com/imprint';

function normalizeUrl(value) {
  if (value == null) return null;
  const trimmed = String(value).trim();
  return trimmed || null;
}

export function resolveImprintUrl(journeyImprint, tenantImprint) {
  return (
    normalizeUrl(journeyImprint) ||
    normalizeUrl(tenantImprint) ||
    DEFAULT_IMPRINT_URL
  );
}

export function resolveDataPrivacyUrl(journeyPrivacy, tenantPrivacy) {
  return normalizeUrl(journeyPrivacy) || normalizeUrl(tenantPrivacy) || null;
}

export function useFooterLegalLinks(journeyImprintUrl, journeyDataPrivacyUrl) {
  const store = useStore();

  const imprintUrl = computed(() =>
    resolveImprintUrl(
      unref(journeyImprintUrl),
      store.state.tenant.tenantinfo?.imprintUrl
    )
  );

  const dataPrivacyUrl = computed(() =>
    resolveDataPrivacyUrl(
      unref(journeyDataPrivacyUrl),
      store.state.tenant.tenantinfo?.dataPrivacyUrl
    )
  );

  return { imprintUrl, dataPrivacyUrl };
}
